<div class="supplementary-equipment">
  <div class="form-box">
    <sc-flex vertical stretchContent>
      <h5>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.available.title"></sc-dictionary-label>
      </h5>
      <div class="form-checkbox" *ngIf="availableEquipment.length === 0">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.noEquipmentAvailable"></sc-dictionary-label>
      </div>
      <div class="form-checkbox" *ngFor="let se of availableEquipment">
        <div class="checkbox-label">
          <mat-checkbox [(ngModel)]="se.selected" name="{{getSeCbxName(se)}}" [ngModelOptions]="{standalone: false}">
            <sc-dictionary-label [dictionaryKey]="se.dictionaryKey"></sc-dictionary-label>
          </mat-checkbox>
        </div>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isStringParameter(se)" appearance="fill">
          <mat-label>
            <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
          </mat-label>
          <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}" required
            [disabled]="!se.selected" name="{{getSeValueName(se)}}">
        </mat-form-field>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isNumberParameter(se)" appearance="fill">
          <mat-label>
            <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
          </mat-label>
          <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}"
            required [disabled]="!se.selected" name="{{getSeValueName(se)}}">
        </mat-form-field>
      </div>
      <h5>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.assigned.title"></sc-dictionary-label>
      </h5>
      <div class="form-checkbox" *ngIf="truck.equipment.length === 0">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.noEquipmentAssigned"></sc-dictionary-label>
      </div>
      <div class="form-checkbox" *ngFor="let se of truck.equipment">
        <div class="checkbox-label">
          <mat-checkbox [(ngModel)]="se.selected" name="{{getSeCbxName(se)}}" [ngModelOptions]="{standalone: false}">
            <sc-dictionary-label [dictionaryKey]="se.dictionaryKey"></sc-dictionary-label>
          </mat-checkbox>
        </div>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isStringParameter(se)" appearance="fill">
          <mat-label>
            <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
          </mat-label>
          <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}" required
            [disabled]="!se.selected" name="{{getSeValueName(se)}}">
        </mat-form-field>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isNumberParameter(se)" appearance="fill">
          <mat-label>
            <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
          </mat-label>
          <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}"
            required [readonly]="true" name="{{getSeValueName(se)}}">
        </mat-form-field>
      </div>
    </sc-flex>
  </div>
</div>
